import { initCarousels } from './home/Slider';

(async () => {
  initCarousels();
})();
